import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../services/authService';

const userFromStorage= localStorage.getItem("user")


const initialState = {
  user: userFromStorage ? JSON.parse(userFromStorage) : null,
  authStatus: "ndle",
}

export const register = createAsyncThunk (
  'auth/register',
  async (user, thunkAPI) => {
    try {
      return await authService.register (user);
    } catch (err) {
      const message =
        (err.response &&
          err.response.data &&
          err.response.data.message) ||
        err.message ||
        err.toString ();
      return thunkAPI.rejectWithValue (message);
    }
  }
);

export const login = createAsyncThunk(
  'auth/login',
  async (payload, thunkAPI) => {
    try {
      const response= await authService.login(payload);
      if (!response.success) {
        return thunkAPI.rejectWithValue(response.message);
      }else{
        return response;
      }
    } catch (err) {
      const message =
        (err.response &&
          err.response.data &&
          err.response.data.message) ||
        err.message ||
        err.toString ();
      return thunkAPI.rejectWithValue(message);
    }
    
  }
);


export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      localStorage.removeItem('user');
      state=initialState;
    },
    clearUser: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase (register.pending, state => {
        state.authStatus = "loading";
      })
      .addCase (register.fulfilled, (state, action) => {
        state.authStatus = "success";
        state.isSuccess = true;
        state.user.unshift(action.payload.user);
      })
      .addCase (register.rejected, (state, action) => {
        state.authStatus = "success";
      })
      .addCase(login.pending, (state) => {
        state.authStatus = "error";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.authStatus = "success";
        state.user = action.payload.user;
        localStorage.setItem('user', JSON.stringify(action.payload.user));
      })
      .addCase(login.rejected, (state, action) => {
        state.authStatus = "error";
      });
  },
});

export const { logout,clearUser } = authSlice.actions;
export default authSlice.reducer;
